import StorageServices from "../services/storageServices";

export default function useStoreObjects() {
  const store = StorageServices.get("active-stores-object");
  return JSON.parse(store);
}
